// extracted by mini-css-extract-plugin
export default {"checkbox":"Templates_checkbox__eVgzJ"};